module.exports = __webpack_public_path__ + "static/media/plus-icon-disabled.dc6dc2f7.svg";